var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.onClickoutside,
          expression: "onClickoutside"
        }
      ],
      class: [_vm.prefixCls],
      on: { mouseenter: _vm.handleMouseenter, mouseleave: _vm.handleMouseleave }
    },
    [
      _c(
        "div",
        {
          ref: "reference",
          class: _vm.relClasses,
          on: {
            click: _vm.handleClick,
            contextmenu: function($event) {
              $event.preventDefault()
              return _vm.handleRightClick.apply(null, arguments)
            }
          }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "transition-drop" } },
        [
          _c(
            "Drop",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.currentVisible,
                  expression: "currentVisible"
                },
                { name: "transfer-dom", rawName: "v-transfer-dom" }
              ],
              ref: "drop",
              class: _vm.dropdownCls,
              attrs: {
                placement: _vm.placement,
                eventsEnabled: _vm.eventsEnabled,
                "data-transfer": _vm.transfer,
                transfer: _vm.transfer
              },
              nativeOn: {
                mouseenter: function($event) {
                  return _vm.handleMouseenter.apply(null, arguments)
                },
                mouseleave: function($event) {
                  return _vm.handleMouseleave.apply(null, arguments)
                }
              }
            },
            [_vm._t("list")],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3426d2b6", { render: render, staticRenderFns: staticRenderFns })
  }
}